import { Controller } from "@hotwired/stimulus"

// Mirrors the chosen payment method's funding into the hidden `funding` field so
// the server persists it on the lease (the credit-only surcharge gate reads it
// at charge time without re-querying Stripe). Phase 7 autopay enrollment.
export default class extends Controller {
  static targets = ["funding"]

  pick(event) {
    const funding = event.target.dataset.funding || ""
    if (this.hasFundingTarget) {
      this.fundingTarget.value = funding
    }
  }
}
